import React, { useEffect, useState } from 'react'
import AddEditStockRequisitions from '../../../Components/AddEditStockRequisitions/AddEditStockRequisitions'
import { useCreateStockLogMutation, useCreateSupplierInvoiceMutation, useSupplierInvoiceByIdQuery, useSupplierInvoiceDetailsQuery, useUpdateSupplierInvoiceMutation } from '../../../Store/Apis/supplierApis'
import Loader from '../../../Components/Loader/Loader'
import Error from '../../../Components/Error/Error'
import toast from 'react-hot-toast'
import { Link, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import formatDate from '../../../Hooks/formatDate'
import ConfirmRequisitions from '../../../Components/ConfirmRequisitions/ConfirmRequisitions'
import { useUpdateProductOrServieMutation } from '../../../Store/Apis/servicesApi'
import { Dropdown } from 'react-bootstrap'
import getStatusColor from '../../../Hooks/GetStatusColor'
import { isPermissionGranted } from '../../../Hooks/permissionsMiddleware'

const StockRequisitions = () => {
    const user = useSelector((state) => state.auth.user);
    const navigate = useNavigate();
    const [page, setPage] = useState()
    const [sortFilter, setSortFilter] = useState({
        search: '',
        filter: '',
        outletID: ''
    });
    const [confirm, setConfirm] = useState(false)
    
    const requisitionsList = useSupplierInvoiceDetailsQuery({
        REQUE: sortFilter.search,
        outletID: sortFilter.outletID
    })
    
    // ADD FUNCTIONALITY
    const [createSupplierInvoiceMutation] = useCreateSupplierInvoiceMutation()
    const handleCreate = (formData) => {
        console.log(formData)
        createSupplierInvoiceMutation({
            supplierID: formData.supplierName,
            outletID: formData.outletName,
            InvoiceNote: formData.requisitionNote,
            statusInvoice: 1,
            products: formData.products.map((elem) => {
                return({
                    productID: elem.productId,
                    quantity: elem.quantity,
                    childID: elem.childId,
                    serviceTypeID: elem.serviceTypeId
                })
            })
        }).then((res) => {
            if (res?.data?.status === 200) {
                setPage(1)
                toast.success(res?.data?.message, { duration: 7000 });
            } else {
                toast.error(res?.data?.message, { duration: 7000 });
            }
        })
    }


    // EDIT FUNCTIONALITY
    const [editId, setEditId] = useState()
    const requisitionById = useSupplierInvoiceByIdQuery({
        REQUE: editId
    }, {skip: !editId})
    const [updateSupplierInvoiceMutation] = useUpdateSupplierInvoiceMutation()

    const handleEdit = (formData) => {
        updateSupplierInvoiceMutation({
            invoiceID: formData.id,
            supplierID: formData.supplierName,
            outletID: formData.outletName,
            InvoiceNote: formData.requisitionNote,
            statusInvoice: 1,
            productInvoices: formData.products.map((elem)=>({
                productID     : elem.productId,
                productName   : elem.productName,
                quantity      : elem.quantity,
                childID       : elem.childId,
                serviceTypeID : elem.serviceTypeId
            }))
        }).then((res) => {
            if (res?.data?.status === 200) {
                setPage(1)
                toast.success(res?.data?.message, { duration: 7000 });
            } else {
                toast.error(res?.data?.message, { duration: 7000 });
            }
        })
    }

    const [updateService] = useUpdateProductOrServieMutation()
    const [createStockLog] = useCreateStockLogMutation()

    const handleConfirmEdit = (formData) => {
        formData.childRecords.map((elem, i) => {
            const body = {
                id: elem.id,
                productServiceName: elem.productServiceName,
                brandId: elem.brandId,
                outletId: formData.outletID,
                isActive: 1,
                type: formData.type,
                iconID: elem.icon,
                childRecords: [
                    {
                        childId: elem.childId,
                        typeId: elem.typeId,
                        code: elem.code,
                        rate: elem.rate,
                        quantity: elem.quantity,
                        icon: elem.iconString,
                        description: elem.description,
                        costPrice: elem.costPrice,
                        reorderLevel: elem.reorderLevel
                    }
                ]
            }
            updateService(body).then((res)=>{
                if(res?.data?.status == 200) {
                    res?.data.data.childRecords.map((elem, i)=>{
                        createStockLog({
                            invoiceID: formData.invoiceID,
                            userId: user.id,
                            serviceId: res?.data.data.id,
                            serviceTypeId: elem.typeId,
                            stockIn: elem.quantity,
                            stockOut: 0,
                            remark:'',
                        })
                    })
                    // toast.success(res?.data?.message, { duration: 7000 });
                    navigate("/supplier/stock-requisitions")
                    setPage(1)
                } else {
                  toast.error(res?.data?.message, { duration: 7000 })
                }
            }).catch((err)=>{
                console.log(err)
            })
        })

        

        // formData.productDetails.map((elem, i)=>{
        //     createStockLog({
        //         userId: user.id,
        //         invoiceId: formData.invoiceId,
        //         serviceId: elem.serviceId,
        //         serviceTypeId: elem.productTypeId,
        //         stockIn: elem.quantity,
        //         stockOut: 0,
        //         remark:''
        //     }).then((res)=>{
        //         if(res?.data?.status == 200) {
        //             toast.success('Requisition Confirmed', { duration: 7000 });
        //             setPage(1)
        //         } else {
        //             toast.error(res?.data?.message, { duration: 7000 })
        //         }
        //     }).catch((err)=>{
        //         toast.error("Something Went Wrong !!", { duration: 7000 })
        //     })
        // })
    }
    
    useEffect(() => {
        if (user.role !== 'superAdmin') {
          setSortFilter({
            ...sortFilter,
            outletID: user.outletID
          });
        }
    }, []);
    
    // ADD Requisition VIEW
    if(page === 2){
        return(
            <div>
                <div className="row align-items-center justify-content-between mb-3">
                    <div className="col">
                        <h5 className="fw-500 text-white mb-0">Add Requisition</h5>
                    </div>
                    <div className="col-auto">
                        <button 
                        type='button'
                        className="btn btn-icon btn-3 btn-white text-primary mb-0"
                        onClick={()=> setPage(1)}
                        >
                            <i className="fa fa-arrow-left me-2"></i>  Back
                        </button>
                    </div>
                </div>
                <div className="card">
                    <div className="card-body">
                        <AddEditStockRequisitions submit={handleCreate} cancel={setPage}/>
                    </div>
                </div>
            </div>
        )
    }

    // EDIT Requisition VIEW
    if(page === 3){
        return(
            <div>
                <div className="row align-items-center justify-content-between mb-3">
                    <div className="col">
                        <h5 className="fw-500 text-white mb-0">Edit Requisition</h5>
                    </div>
                    <div className="col-auto">
                        <button 
                        type='button'
                        className="btn btn-icon btn-3 btn-white text-primary mb-0"
                        onClick={()=> setPage(1)}
                        >
                            <i className="fa fa-arrow-left me-2"></i>  Back
                        </button>
                    </div>
                </div>
                <div className="card">
                    <div className="card-body">
                        <AddEditStockRequisitions submit={handleEdit} data={requisitionById?.data?.data[0]} cancel={setPage} />
                    </div>
                </div>
            </div>
        )
    } 

    // CONFIRM Requisition
    if(page === 4){
        return(
            <div>
                <div className="row align-items-center justify-content-between mb-3">
                    <div className="col">
                        <h5 className="fw-500 text-white mb-0">Confirm Requisition</h5>
                    </div>
                    <div className="col-auto">
                        <button 
                            type='button'
                            className="btn btn-icon btn-3 btn-white text-primary mb-0"
                            onClick={()=> setPage(1)}
                        >
                            <i className="fa fa-arrow-left me-2"></i> Back
                        </button>
                    </div>
                </div>
                <div className="card">
                    <div className="card-body">
                        <ConfirmRequisitions submit={handleConfirmEdit} data={requisitionById?.data?.data[0]} />
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div>
            <div className="row align-items-center justify-content-between mb-3">
                <div className="col">
                    <h5 className="fw-500 text-white mb-0">External Stock Request</h5>
                </div>
                <div className="col-auto">
                    {
                        isPermissionGranted(2008) && (
                            <button
                                type='button' 
                                className="btn btn-icon btn-3 btn-white text-primary mb-0"
                                onClick={()=> setPage(2)}
                            >
                                <i className="fa fa-plus me-2"></i>  Add Request
                            </button>
                        )
                    }
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="card mb-4">
                        <div className="card-header p-4">
                            <input 
                                type="text" 
                                className="form-control" 
                                placeholder="Search by Requisition number"
                                value={sortFilter?.search || ""}
                                onChange={(e) => setSortFilter({...sortFilter, search: e.target.value})}
                            />
                        </div>
                        <div className="card-body p-0">
                            {requisitionsList.isError && <Error/>}
                            {requisitionsList.isLoading && <Loader height="500px"/>}
                            {requisitionsList.isSuccess && (
                                <>
                                    <div className="table-responsive">
                                        <div className="table align-items-center mb-0">
                                            <table className="table align-items-center mb-0">
                                                <thead className="bg-light">
                                                    <tr>
                                                        <th className="text-uppercase text-secondary text-xs px-4">#</th>
                                                        <th className="text-uppercase text-secondary text-xs px-4">Requisition Number</th>
                                                        <th className="text-uppercase text-secondary text-xs px-4">Requisition Date</th>
                                                        <th className="text-uppercase text-secondary text-xs px-4">Outlet</th>
                                                        <th className="text-uppercase text-secondary text-xs px-4">Supplier Name</th>
                                                        <th className="text-uppercase text-secondary text-xs px-4">Status</th>
                                                        <th className="text-uppercase text-secondary text-xs text-end">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        (Array.isArray(requisitionsList.data.data) && requisitionsList.data.data.length > 0) ? requisitionsList.data.data.map((elem, i)=>{
                                                            return(
                                                                <tr>
                                                                    <td className='px-4'>
                                                                        <div className="d-flex flex-column justify-content-center text-sm">{i+1}</div>
                                                                    </td>
                                                                    <td className='px-4'>
                                                                        <div className="d-flex flex-column justify-content-center text-sm">
                                                                            {elem.invoiceNumber}
                                                                        </div>
                                                                    </td>
                                                                    <td className='px-4'>
                                                                        <div className="d-flex flex-column justify-content-center text-sm">
                                                                            {formatDate(elem.invoiceDate)}
                                                                        </div>
                                                                    </td>
                                                                    <td className='px-4'>
                                                                        <div className="d-flex flex-column justify-content-center text-sm">
                                                                            {elem.outletName}
                                                                        </div>
                                                                    </td>
                                                                    <td className='px-4'>
                                                                        <div className="d-flex flex-column justify-content-center text-sm">
                                                                            {elem.supplierName}
                                                                        </div>
                                                                    </td>
                                                                    <td className='px-4'>
                                                                        <span
                                                                            className={`badge badge-sm text-uppercase badge-${getStatusColor(elem.requisitonStatusName)}`}
                                                                            style={{ cursor: "default" }}
                                                                        >
                                                                            {elem.requisitonStatusName}
                                                                        </span>
                                                                    </td>
                                                                    <td className='px-4 text-end'>
                                                                        <Dropdown className='resetDropdownArrow'>
                                                                            <Dropdown.Toggle variant="Secondary" className='btn-sm mb-0'>
                                                                                <i className="fa fa-ellipsis-h"></i>
                                                                            </Dropdown.Toggle>
                                                                            <Dropdown.Menu>
                                                                                {
                                                                                    (elem.requisitionStatus !== 4) && (
                                                                                        <Dropdown.Item onClick={()=> (setPage(3), setEditId(elem.invoiceNumber))}>
                                                                                            {(elem.requisitionStatus === 2 || elem.requisitionStatus === 3) ? 'View' : 'View & Edit'}
                                                                                        </Dropdown.Item>
                                                                                    )
                                                                                }
                                                                                {
                                                                                    (elem.requisitionStatus === 4 && elem.confirmed === 0) && (
                                                                                        <Dropdown.Item onClick={()=> (setPage(4),setEditId(elem.invoiceNumber), setConfirm(true))}>
                                                                                            Receive stock
                                                                                        </Dropdown.Item>
                                                                                    )                                                                                
                                                                                }
                                                                                <Dropdown.Item as={Link} to={`print?invoiceNumber=${elem.invoiceNumber}`}>
                                                                                    Download
                                                                                </Dropdown.Item>
                                                                            </Dropdown.Menu>
                                                                        </Dropdown>
                                                                    </td> 
                                                                </tr>
                                                            )
                                                        }) : <td colSpan={6} className='text-center text-sm py-5'>No data found !!</td>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </>
                            )}                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StockRequisitions